module.exports = __webpack_public_path__ + "static/media/empty-state-video-bank.7e7249dd.svg";